// Pure helpers for the EmailComposer template picker (polish #41).
//
// Extracted into a non-JSX module so the unit tests under
// tests/web/ can import without pulling React/TSX through the root
// tsconfig (which doesn't carry --jsx). Same pattern as
// communication-templates-helpers, automation-builder-helpers, etc.

/**
 * Convert a stored template body (which may be plain text or HTML)
 * into something contentEditable will render. Plain text gets split
 * on double-newline → paragraph, single-newline → <br>. Existing
 * HTML passes through untouched. Merge tokens (`{{...}}`) are
 * preserved verbatim — the composer doesn't auto-resolve them.
 */
export function bodyTemplateToHtml(body: string): string {
  if (/<[a-z][\s\S]*>/i.test(body)) {
    return body;
  }
  return body
    .split(/\n\n+/)
    .map((para) => `<p>${escapeHtml(para).replace(/\n/g, "<br>")}</p>`)
    .join("");
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
